/*
 * @Author: Suroc
 * @Date: 2024-07-10 09:57:16
 * @LastEditTime: 2024-12-24 14:46:00
 * @Description: 
 */
import { ElMessage } from 'element-plus'
import { baseURL } from "./request/https"
const tool = {}
/**
 * @description ToWei精度转换
 * @param {val} - 转换金额
 */
tool.ToWei = (val) => {
  return web3.utils.toWei(val, 'ether')
}
/**
 * @description FromWei精度转换
 * @param {val} - 转换金额
 * @param {fixed} - 省略位数
 */
tool.FromWei = (val, fixed) => {
  // 将 wei 单位的金额转换为 ether 单位
  const etherValue = web3.utils.fromWei(val, 'ether');
  // 将转换后的值转换为浮点数
  const floatValue = parseFloat(etherValue);
  if (Number.isInteger(floatValue)) {
    return parseFloat(floatValue);
  } else {
    let fixedValue = floatValue.toFixed(fixed ? fixed : 5);
    return parseFloat(fixedValue).toString();
  }
}
/**
 * @description 处理用户过长
 * @param {account} - 用户账户
 * @param {num} - 省略位数
 */
tool.maskAccount = (account, num = 4) => {
  if(!account||account=="0x0000000000000000000000000000000000000000"){
    return null
  }
  const regex = new RegExp(`^(.{${num}})(.*)(.{${num}})$`);
  return account.replace(regex, (match, p1, p2, p3) => {
    return `${p1}****${p3}`;
  });
}
/**
 * @description 倒计时处理
 * @param {endTime} - 结束时间（秒）
 * @param {startTime} - 开启时间（秒）
 */
tool.initCountDown = (endTime, startTime) => {

  if (!parseFloat(endTime) || !parseFloat(startTime)) {
    return null
  } else {
    return Math.floor(parseFloat(endTime) - parseFloat(startTime))
  }
}
/**
 * @description 倒计时结束日期
 * @param {totals} - 总秒数（秒）
 */
tool.endDateFrom = (totals) => {
  const currentTimes = Math.floor(Date.now() / 1000);
  const endTimes = currentTimes + totals;
  const endDate = new Date(endTimes * 1000); // 转换为毫秒
  // 格式化日期为 YYYY-MM-DD
  const year = endDate.getFullYear();
  const month = String(endDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以需要+1
  const day = String(endDate.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
/**
 * @description 当前月份
 */
tool.formatDateMonth = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 将月份补足两位
  return `${year}-${month}`;
}
/**
 * @description 将 0-1 范围的数字转换为百分比格式
 * @param {number} value - 范围在 0 到 1 之间的数字
 * @param {number} decimals - 保留的小数位数
 * @returns {string} - 转换后的百分比字符串
 */
tool.toPercentage = (value, decimals) => {
  if (value < 0 || value > 1) {
    throw new Error("值必须在 0 到 1 之间");
  }
  // 将值转换为百分比
  const percentage = (value * 100).toFixed(decimals);
  // 根据小数点后的第一位判断是否需要添加符号
  const [integerPart, decimalPart] = percentage.split('.');
  let sign = '';

  // 特殊情况处理：值为0时直接返回 "0.00%"
  if (value === 0) {
    return '0.00%';
  }

  if (parseFloat(percentage) < 0.01) {
    return '<0.01%';
  } else if (decimalPart[0] >= '5') {
    sign = '>'; // 小数点后第一位 >= 5 时，使用 '>'
  } else if (decimalPart[0] < '5' && decimalPart[0] > '0') {
    sign = '<'; // 小数点后第一位 > 0 且 < 5 时，使用 '<'
  }
  // 返回格式化后的百分比字符串，前面加上符号
  return `${sign}${percentage}%`;
}
/**
 * @description 计算占比
 * @param {total} - 数量
 * @param {percentage} - 百分比
 */
tool.calculatePercentage = (total, percentage) => {
  let val = web3.utils.toWei(total, 'ether')
  let newVal = val * (percentage / 100);
  return web3.utils.fromWei(newVal, 'ether')
}
/**
 * @description 秒数转倒计时（DD:HH:MM:SS）
 * @param {seconds} - 秒数
 */
tool.secondToTime = (seconds) => {
  const days = Math.floor(parseFloat(seconds) / 86400); // 一天有 86400 秒
  const hours = Math.floor((parseFloat(seconds) % 86400) / 3600);
  const minutes = Math.floor((parseFloat(seconds) % 3600) / 60);
  const secs = parseFloat(seconds) % 60;

  return `${String(days).padStart(2, '0')}:${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
}

/**
 * @description 时间戳转换为 'yyyy-mm-dd'格式的函数
 * @param {timestamp} - 合约时间戳
 */
tool.formatToDate = (timestamp) => {
  const date = new Date(Number(timestamp) * 1000) // 将秒转换为毫秒
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // 月份从 0 开始，所以要 +1
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const mins = String(date.getMinutes()).padStart(2, '0')
  const sens = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${mins}:${sens}`
}
/**
 * @description 复制信息
 * @param {domId} - 消息内容
 * @param {type} - text/input/textarea
 */
tool.copyValue = (domId, type) => {
  switch (type) {
    case 'text':
      navigator.clipboard.writeText(domId)
      break;
    case 'input':
      let inputElement = $(`#${domId} input`);
      inputElement.select();
      document.execCommand('copy');
      break;
    case 'textarea':
      let textareaElement = $(`#${domId}`);
      textareaElement.select();
      document.execCommand('copy');
      break;
    default:
      break;
  }
}
/**
 * @description 消息提示框
 * @param {val} - 消息内容
 * @param {type} - 消息类型 null/success/warning/error
 */
tool.openMessage = (val, type) => {
  switch (type) {
    case 'success':
      ElMessage.success(val)
      break;
    case 'warning':
      ElMessage.warning(val)
      break;
    case 'error':
      ElMessage.error(val)
      break;
    default:
      ElMessage(val)
      break;
  }
}

tool.urlImages = (url) => {
  let image = ""
  if (!url) return ""
  if (/^(https?:\/\/|data:image\/(?:jpeg|png|gif|bmp|webp);base64,).+$/.test(url)) {
    image = url
  } else {
    image = baseURL + url
  }
  return image
}
export default tool
